import { useEffect } from 'react';
import { PageController } from '@sitecore-search/core';
import useBaseWidget from './useBaseWidget.js';
import { useHandlerRef } from './utils.js';
const useWidgetActionsHandler = (handler, deps) => {
    const { rfkId, instanceId } = useBaseWidget();
    const actionReducer = useHandlerRef(handler, deps);
    useEffect(() => {
        const listener = {
            handleAction(action) {
                const { rfkId: id, instanceId: instance } = action.payload;
                if (!id || (id === rfkId && instance === instanceId)) {
                    actionReducer.current(action);
                }
            },
        };
        PageController.register(listener);
        return () => PageController.unregister(listener);
        // react-hooks/exhaustive-deps doesn't detect that actionReducer is a ref (refs are safe to use in effects)
        // no matter what, since actionReducer is a reference and won't change, it won't trigger the effect
    }, [rfkId, instanceId, actionReducer]);
};
export default useWidgetActionsHandler;
